export const releaseAntModalLock = () => {
  window.setTimeout(() => {
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("padding-right");
    document.body.style.removeProperty("width");
    document.body.style.removeProperty("position");
    document.documentElement.style.removeProperty("overflow");
    document.documentElement.style.removeProperty("padding-right");
    document.body.classList.remove("ant-scrolling-effect");
    document.documentElement.classList.remove("ant-scrolling-effect");

    document.querySelectorAll("body > .ant-modal-root").forEach((root) => {
      if (!root.querySelector(".ant-modal-open")) {
        root.remove();
      }
    });

    window.dispatchEvent(new Event("resize"));
  }, 320);
};
